// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2SM1-","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3TfQy"};